angular.module('smartorg.r6.acts.tornado', []);
require('./tornado-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.acts.tornado';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/tornado/app/js/plumbing/app.js